import React from 'react';
import { ArrowRight, BarChart3, Target, Zap, Database } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { StatBlock } from '../components/ui/StatBlock';
import { ClientTicker } from '../components/ui/ClientTicker';
import { Input } from '../components/ui/Input';
export function Home() {
  return <div className="w-full" data-id="element-753">
      {/* Hero Section */}
      <section className="relative min-h-[500px] md:min-h-[85vh] flex items-center justify-center pt-20 py-10 md:py-16 overflow-hidden" data-id="element-754">
        {/* Cinematic background gradient/glow */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(252,198,13,0.05)_0%,rgba(0,0,0,1)_70%)]" data-id="element-755" />

        <div className="relative z-10 max-w-5xl mx-auto px-4 text-center flex flex-col items-center mt-12 md:mt-16" data-id="element-756">
          <span className="text-engage-yellow font-bold tracking-[0.1em] text-[9px] xs:text-[10px] sm:text-xs md:text-base mb-4 uppercase animate-fade-in-up whitespace-nowrap" data-id="element-757">
            Content Creation | Paid Advertising | Funnels
          </span>
          <h1 className="md:text-7xl lg:text-8xl font-black text-engage-white mb-5 tracking-tight text-balance text-[35px]" data-id="element-758">
            Where Creativity Meets{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-engage-white to-engage-gray4" data-id="element-759">
              Performance
            </span>
          </h1>
          <p className="text-lg md:text-xl text-engage-gray4 max-w-2xl mb-7 text-balance" data-id="element-760">
            We build growth engines that move people, drive action, and generate
            real revenue for ambitious brands.
          </p>
          <Button to="/contact" variant="primary" className="text-lg px-8 py-4" data-id="element-761">
            Book a Call With Us
          </Button>
        </div>
      </section>

      {/* Client Logos Carousel Section */}
      <section className="py-12 bg-engage-gray1 relative overflow-hidden" data-id="element-762">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(252,198,13,0.03)_0%,transparent_60%)] pointer-events-none" data-id="element-763" />
        <div className="relative z-10 max-w-7xl mx-auto px-4" data-id="element-764">
          <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8" data-id="element-765">
            {/* Chip/Tag Label - centered on mobile, left on desktop */}
            <span className="border-2 border-engage-yellow text-engage-white text-xs font-semibold uppercase tracking-wide px-4 py-2 rounded-full whitespace-nowrap shrink-0" data-id="element-766">
              Trusted by Leading Brands
            </span>
            {/* Carousel taking remaining space */}
            <div className="w-full md:flex-1 relative overflow-hidden" data-id="element-767">
              <div className="flex" data-id="element-768">
                {[0, 1].map(setIndex => <div key={setIndex} className="flex shrink-0 items-center gap-8 md:gap-16 pr-8 md:pr-16 animate-logo-scroll" data-id="element-769">
                    <img src="https://cdn.magicpatterns.com/uploads/6kgibo1RnRcCbDvKVJS3Lu/Logo-The-Christmas-Palace.png" alt="The Christmas Palace" className="h-20 w-auto object-contain shrink-0" data-id="element-770" />
                    <img src="https://cdn.magicpatterns.com/uploads/9m9ezirWgVJHARCigZFgh9/Z-Roofing.png" alt="Z Roofing" className="h-20 w-auto object-contain shrink-0" data-id="element-771" />
                    <img src="https://cdn.magicpatterns.com/uploads/wJhjYS3o8Eu6CBJ2vRY5Wa/Logo-Level-Up-Insurance.png" alt="Level Up Insurance" className="h-20 w-auto object-contain shrink-0" data-id="element-772" />
                    <img src="https://cdn.magicpatterns.com/uploads/gFP8PtEhJGxGGu1ofodZsj/Logo-Xclusive-Agent-Leads.png" alt="Xclusive Agent Leads" className="h-20 w-auto object-contain shrink-0" data-id="element-773" />
                    <img src="https://cdn.magicpatterns.com/uploads/mhHKTX4VkSDNuJTWP1gncJ/Logo-Casa-Wagyu.png" alt="Casa Wagyu" className="h-20 w-auto object-contain shrink-0" data-id="element-774" />
                    <img src="https://cdn.magicpatterns.com/uploads/m3d8to4jrYnQ7wdpBu4LqM/Logo-Omnicredit.png" alt="Omnicredit" className="h-20 w-auto object-contain shrink-0" data-id="element-775" />
                    <img src="https://cdn.magicpatterns.com/uploads/ePG9ymzHfpNVHNd8RfG8sQ/Logo-Winners-Mindset.png" alt="Winners Mindset" className="h-20 w-auto object-contain shrink-0" data-id="element-776" />
                    <img src="https://cdn.magicpatterns.com/uploads/2ScwJcYowcVKwXTHwUS5pZ/Logo-Watch-Me-Grow-Learning-Center.png" alt="Watch Me Grow Learning Center" className="h-20 w-auto object-contain shrink-0" data-id="element-777" />
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Client Ticker */}
      <ClientTicker data-id="element-778" />

      {/* Intro Section */}
      <section className="py-24 md:py-32 bg-engage-black" data-id="element-779">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-780">
          <h2 className="text-3xl md:text-[56px] font-bold text-engage-white mb-4 tracking-tight" data-id="element-781">
            We don't just market your brand.
          </h2>
          <h2 className="text-5xl md:text-7xl font-black text-engage-yellow mb-8 tracking-tight" data-id="element-782">
            We Engage it.
          </h2>
          <p className="text-xl md:text-2xl text-engage-gray4 mb-12 leading-relaxed text-balance" data-id="element-783">
            From content to ads to conversion systems, we build growth engines
            that move people, drive action, and generate real revenue.
          </p>
          <Button to="/case-studies" variant="secondary" data-id="element-784">
            See Our Results
          </Button>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-24 bg-engage-gray1 border-y border-engage-gray2 relative overflow-hidden" data-id="element-785">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-[radial-gradient(ellipse_at_top,rgba(252,198,13,0.03)_0%,transparent_70%)]" data-id="element-786" />
        <div className="max-w-7xl mx-auto px-4 relative z-10" data-id="element-787">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-788">
            Our Results, Your Growth
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8" data-id="element-789">
            <StatBlock number="$80M+" label="Annual Client Revenue" data-id="element-790" />
            <StatBlock number="$1.3M+" label="Ad Spend Per Year" data-id="element-791" />
            <StatBlock number="16" label="Engage Marketers" data-id="element-792" />
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="py-24 md:py-32 bg-engage-black" data-id="element-793">
        <div className="max-w-7xl mx-auto px-4" data-id="element-794">
          <div className="flex flex-col md:flex-row justify-between items-center md:items-end mb-16 gap-6 text-center md:text-left" data-id="element-795">
            <div data-id="element-796">
              <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-797">
                The Engage Machine
              </h2>
              <p className="text-engage-gray4 text-lg max-w-xl mx-auto md:mx-0" data-id="element-798">
                A unified engine combining media buying, creative production,
                and funnel strategy.
              </p>
            </div>
            <Button to="/services" variant="secondary" className="shrink-0" data-id="element-799">
              Let's Scale
            </Button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-800">
            <Card accent className="group cursor-pointer" data-id="element-801">
              <Target className="w-12 h-12 text-engage-yellow mb-6" data-id="element-802" />
              <h3 className="text-2xl font-bold mb-4" data-id="element-803">Conversion</h3>
              <p className="text-engage-gray4" data-id="element-804">
                Turn your website into a system that converts attention into
                customers.
              </p>
            </Card>
            <Card accent className="group cursor-pointer" data-id="element-805">
              <Zap className="w-12 h-12 text-engage-yellow mb-6" data-id="element-806" />
              <h3 className="text-2xl font-bold mb-4" data-id="element-807">Content</h3>
              <p className="text-engage-gray4" data-id="element-808">
                Create content that captures attention and drives action.
              </p>
            </Card>
            <Card accent className="group cursor-pointer" data-id="element-809">
              <ArrowRight className="w-12 h-12 text-engage-yellow mb-6" data-id="element-810" />
              <h3 className="text-2xl font-bold mb-4" data-id="element-811">Traffic</h3>
              <p className="text-engage-gray4" data-id="element-812">
                Bring the right people into your business, consistently.
              </p>
            </Card>
            <Card accent className="group cursor-pointer" data-id="element-813">
              <Database className="w-12 h-12 text-engage-yellow mb-6" data-id="element-814" />
              <h3 className="text-2xl font-bold mb-4" data-id="element-815">Data</h3>
              <p className="text-engage-gray4" data-id="element-816">
                Use performance data to make smarter decisions and scale faster.
              </p>
            </Card>
          </div>
        </div>
      </section>

      {/* Case Studies Preview */}
      <section className="py-24 md:py-32 bg-engage-gray1" data-id="element-817">
        <div className="max-w-7xl mx-auto px-4" data-id="element-818">
          <div className="flex flex-col md:flex-row justify-between items-center md:items-end mb-16 gap-6 text-center md:text-left" data-id="element-819">
            <h2 className="text-4xl md:text-5xl font-bold" data-id="element-820">Case Studies</h2>
            <Button to="/case-studies" variant="secondary" className="shrink-0" data-id="element-821">
              Explore All Case Studies
            </Button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-822">
            <Card accent className="flex flex-col h-full group" data-id="element-823">
              <div className="flex-grow" data-id="element-824">
                <div className="flex flex-wrap gap-2 mb-6" data-id="element-825">
                  <span className="px-3 py-1 bg-engage-gray2 text-engage-gray5 text-xs font-semibold uppercase tracking-wider rounded-full" data-id="element-826">
                    Lead Gen
                  </span>
                  <span className="px-3 py-1 bg-engage-gray2 text-engage-gray5 text-xs font-semibold uppercase tracking-wider rounded-full" data-id="element-827">
                    Paid Social
                  </span>
                  <span className="px-3 py-1 bg-engage-gray2 text-engage-gray5 text-xs font-semibold uppercase tracking-wider rounded-full" data-id="element-828">
                    Financial Services
                  </span>
                </div>
                <span className="text-engage-yellow font-bold text-sm uppercase tracking-wider mb-2 block" data-id="element-829">
                  Omnicredit
                </span>
                <h3 className="text-3xl font-bold mb-4 group-hover:text-engage-yellow transition-colors" data-id="element-830">
                  From Zero to $40K/Month in Just 4 Months
                </h3>
                <p className="text-engage-gray4 text-lg mb-8" data-id="element-831">
                  How we built a complete acquisition system from scratch for an
                  early-stage financial brand—going from zero infrastructure to
                  $40K/month in just four months.
                </p>
              </div>
              <Link to="/case-studies/omnicredit" className="inline-flex items-center gap-2 text-engage-gray4 font-semibold mt-auto group-hover:text-engage-yellow transition-colors duration-300" data-id="element-832">
                <span data-id="element-833">View Case Study</span>
                <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform duration-300" data-id="element-834" />
              </Link>
            </Card>
            <Card accent className="flex flex-col h-full group" data-id="element-835">
              <div className="flex-grow" data-id="element-836">
                <div className="flex flex-wrap gap-2 mb-6" data-id="element-837">
                  <span className="px-3 py-1 bg-engage-gray2 text-engage-gray5 text-xs font-semibold uppercase tracking-wider rounded-full" data-id="element-838">
                    E-Commerce Growth
                  </span>
                  <span className="px-3 py-1 bg-engage-gray2 text-engage-gray5 text-xs font-semibold uppercase tracking-wider rounded-full" data-id="element-839">
                    Multi-Channel Scaling
                  </span>
                </div>
                <span className="text-engage-yellow font-bold text-sm uppercase tracking-wider mb-2 block" data-id="element-840">
                  The Christmas Palace
                </span>
                <h3 className="text-3xl font-bold mb-4 group-hover:text-engage-yellow transition-colors" data-id="element-841">
                  Turning Content into Holiday Demand at Scale
                </h3>
                <p className="text-engage-gray4 text-lg mb-8" data-id="element-842">
                  How we built a content-first growth engine that generated 8M+
                  views in 90 days, turning social content into real-world
                  holiday demand and foot traffic.
                </p>
              </div>
              <Link to="/case-studies/christmas-palace" className="inline-flex items-center gap-2 text-engage-gray4 font-semibold mt-auto group-hover:text-engage-yellow transition-colors duration-300" data-id="element-843">
                <span data-id="element-844">View Case Study</span>
                <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform duration-300" data-id="element-845" />
              </Link>
            </Card>
            <Card accent className="flex flex-col h-full group" data-id="element-846">
              <div className="flex-grow" data-id="element-847">
                <div className="flex flex-wrap gap-2 mb-6" data-id="element-848">
                  <span className="px-3 py-1 bg-engage-gray2 text-engage-gray5 text-xs font-semibold uppercase tracking-wider rounded-full" data-id="element-849">
                    Scaling
                  </span>
                  <span className="px-3 py-1 bg-engage-gray2 text-engage-gray5 text-xs font-semibold uppercase tracking-wider rounded-full" data-id="element-850">
                    Paid Search
                  </span>
                </div>
                <span className="text-engage-yellow font-bold text-sm uppercase tracking-wider mb-2 block" data-id="element-851">
                  Levelup Insurance
                </span>
                <h3 className="text-3xl font-bold mb-4 group-hover:text-engage-yellow transition-colors" data-id="element-852">
                  Scaling High-Quality Leads Nationwide
                </h3>
                <p className="text-engage-gray4 text-lg mb-8" data-id="element-853">
                  How we built a bilingual lead acquisition system that scaled
                  from $3K to $70K/month in ad spend—while improving lead
                  quality and expanding nationwide.
                </p>
              </div>
              <Link to="/case-studies/levelup-insurance" className="inline-flex items-center gap-2 text-engage-gray4 font-semibold mt-auto group-hover:text-engage-yellow transition-colors duration-300" data-id="element-854">
                <span data-id="element-855">View Case Study</span>
                <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform duration-300" data-id="element-856" />
              </Link>
            </Card>
            <Card accent className="flex flex-col h-full group" data-id="element-857">
              <div className="flex-grow" data-id="element-858">
                <div className="flex flex-wrap gap-2 mb-6" data-id="element-859">
                  <span className="px-3 py-1 bg-engage-gray2 text-engage-gray5 text-xs font-semibold uppercase tracking-wider rounded-full" data-id="element-860">
                    Local Service
                  </span>
                  <span className="px-3 py-1 bg-engage-gray2 text-engage-gray5 text-xs font-semibold uppercase tracking-wider rounded-full" data-id="element-861">
                    Brand Authority
                  </span>
                </div>
                <span className="text-engage-yellow font-bold text-sm uppercase tracking-wider mb-2 block" data-id="element-862">
                  Z Roofing and Waterproofing
                </span>
                <h3 className="text-3xl font-bold mb-4 group-hover:text-engage-yellow transition-colors" data-id="element-863">
                  Building a Trusted Local Brand
                </h3>
                <p className="text-engage-gray4 text-lg mb-8" data-id="element-864">
                  How we transformed a local roofing company's digital presence
                  into a trust-building asset—aligning their online image with
                  the quality of their work.
                </p>
              </div>
              <Link to="/case-studies/z-roofing" className="inline-flex items-center gap-2 text-engage-gray4 font-semibold mt-auto group-hover:text-engage-yellow transition-colors duration-300" data-id="element-865">
                <span data-id="element-866">View Case Study</span>
                <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform duration-300" data-id="element-867" />
              </Link>
            </Card>
          </div>
        </div>
      </section>

      {/* Careers Section */}
      <section className="py-32 bg-engage-black relative overflow-hidden" data-id="element-868">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(252,198,13,0.08)_0%,transparent_60%)]" data-id="element-869" />
        <div className="max-w-4xl mx-auto px-4 text-center relative z-10" data-id="element-870">
          <span className="text-engage-yellow font-bold tracking-[0.2em] text-sm uppercase mb-6 block" data-id="element-871">
            Join Our Team
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-balance" data-id="element-872">
            Build the Future of Performance Marketing
          </h2>
          <p className="text-engage-gray4 text-lg md:text-xl mb-10 max-w-2xl mx-auto text-balance" data-id="element-873">
            We're always looking for ambitious, analytical, creative minds ready
            to scale brands globally.
          </p>
          <Button to="/careers" variant="primary" className="text-lg px-8 py-4" data-id="element-874">
            Explore Open Positions
          </Button>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-24 bg-engage-gray1" data-id="element-875">
        <div className="max-w-2xl mx-auto px-4" data-id="element-876">
          <Card className="bg-engage-black border border-engage-gray2 text-center" data-id="element-877">
            <div className="mb-8" data-id="element-878">
              <h3 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-879">
                Stay Ahead of the Curve
              </h3>
              <p className="text-engage-gray4 text-lg" data-id="element-880">
                Get weekly insights on performance marketing, creative strategy,
                and scaling brands delivered to your inbox.
              </p>
            </div>
            <form className="flex flex-col sm:flex-row gap-4" onSubmit={e => e.preventDefault()} data-id="element-881">
              <Input label="" placeholder="Enter your email" type="email" className="flex-grow !space-y-0" required data-id="element-882" />
              <Button type="submit" variant="primary" className="whitespace-nowrap px-8" data-id="element-883">
                Subscribe
              </Button>
            </form>
          </Card>
        </div>
      </section>
    </div>;
}